const styles = (theme) => ({
	ContainerBox: {
		display: "flex",
		width: "100%",
		marginTop: "40px",
		justifyContent: "center",
		alignItems: " center",
		flexShrink: 0,
	},
	TextCampo: {
		width: "100%",
		minWidht: "220px",
		borderRadius: "8px",
		bgcolor:
			theme.palette.mode == "dark"
				? theme.palette.secondary.dark
				: theme.palette.secondary.light,
		"& .MuiFilledInput-root": {
			backgroundColor: "transparent",
		},
		"& .Mui-disabled": {
			backgroundColor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.dark
					: theme.palette.secondary.light,
			borderRadius: "8px",
		},
		"& .MuiFilledInput-root:hover": {
			bgcolor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.darker
					: theme.palette.secondary.light,
		},
		"& .MuiInputLabel-filled": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.secondary.dark,
		},
		"& .MuiFilledInput-input": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.white.main
					: theme.palette.colors.black.dark,
		},
		"& .MuiInputBase-input.Mui-disabled": {
			WebkitTextFillColor:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.colors.black.medium,
		},
	},
	TextCampoSecondary: {
		width: "100%",
	},
	Paper: {
		justifyContent: "flex-start",
		alignItems: " center",
		maxWidth: "980px",
		padding: "24px",
		height: "auto",
		display: "flex",
		flexDirection: "column",
		gap: 2,
		background: theme.palette.secondary.darker,
		borderRadius: "16px",
		position: "relative",

		//  margin: "200px",
	},
	Title: {
		fontWeight: "400",
		color: theme.palette.white.main,
		// mb: 1,
	},
	StackPage: {
		background: theme.palette.background.modalContrast,
		display: "flex",
		flexDirection: "column",

		paddingY: {
			sm: "40px",
		},
		paddingX: "10px",
		gap: "16px",
		borderRadius: "20px",
		width: "100%",
	},
	ButtonFoto: {
		position: "absolute",
		display: "flex",
		alignItems: "center",
		mt: 1.5,
		ml: 8,
		gap: "8px",
		fontSize: "15px",
		bgcolor: theme.palette.colors.pink.medium,
		transition: "background 0.2s",
		"&:hover": {
			bgcolor: theme.palette.colors.pink.dark,
			boxShadow: `0px 2px 8px ${theme.palette.colors.black.darker}26`,
		},
	},
	StackFoto: {
		width: "100%",
		alignItems: "flex-start",
	},
	Avatar: {
		transform: "translateX(-50%)",
		position: "absolute",
		left: 85,
		top: 55,
		height: "90px",
		width: "90px",
		border: "4px solid",
		borderColor: theme.palette.secondary.darker,
		color: theme.palette.white.main,
		background:
			theme.palette.mode == "dark"
				? theme.palette.colors.gray.dark
				: theme.palette.black.light,
		"@media (max-width: 475px)": {
			display: "none",
		},
	},
	ButtonCadastrar: { width: "430px", borderRadius: "10px", height: "40px" },
	HeaderBox: {
		display: "flex",
		alignItems: "center",
		width: "100%",
		justifyContent: "flex-start",
		gap: 18,
		mb: 2,
	},
	BackButtonIcon: {
		color: theme.palette.white.main,
	},
	AddPhotoIcon: {
		color: "white.main",
	},
	RowStack: {
		display: "flex",
		width: "100%",
		gap: 1,
	},
});
export default styles;
